<template>
  <span class="media-icon-wrap" :style="wrapStyle">
    <img :src="url" alt="icon">
  </span>
</template>

<script>
// import { calcVw, calcVh } from '@/utils'

export default {
  props: {
    url: String,
    width: Number,
    height: Number
  },
  data () {
    return {

    }
  },
  computed: {
    wrapStyle () {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      }
    }
  }
}
</script>
